export default "__VITE_ASSET__DBXmvXjS__"